var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "social"
    }
  }, [_c("a-card", {
    staticClass: "content",
    attrs: {
      bordered: false
    }
  }, [_c("a-alert", {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      message: _vm.$t("basicSettings.warmPrompt"),
      description: _vm.$t("socialLogin.decp"),
      type: "warning",
      "show-icon": "",
      closable: ""
    }
  }), _c("StandardTableVue", {
    attrs: {
      columns: _vm.columns,
      dataSource: _vm.data,
      pagination: false,
      rowKey: "id",
      loading: _vm.tableLoading
    },
    scopedSlots: _vm._u([{
      key: "showOrder",
      fn: function fn(_ref) {
        var record = _ref.record;
        return _c("span", {}, [_vm._v(" " + _vm._s(record.showOrder) + " ")]);
      }
    }, {
      key: "loginSwitch",
      fn: function fn(_ref2) {
        var text = _ref2.text;
        return _c("span", {}, [_c("a-tag", {
          attrs: {
            color: text === 0 ? "red" : "blue"
          }
        }, [_vm._v(" " + _vm._s(text == 0 ? _vm.$t("disabled") : _vm.$t("Enable")) + " ")])], 1);
      }
    }, {
      key: "nfOpen",
      fn: function fn(_ref3) {
        var record = _ref3.record;
        return _c("span", {}, [record.platformType == 0 || record.platformType == 4 ? _c("span", [_vm._v(" " + _vm._s(record.nfOpen == 0 ? _vm.$t("public.close") : _vm.$t("public.open")) + " ")]) : _c("span", [_vm._v(" -- ")])]);
      }
    }, {
      key: "action",
      fn: function fn(_ref4) {
        var record = _ref4.record;
        return _c("span", {}, [_c("a", {
          staticClass: "ant-dropdown-link",
          on: {
            click: function click($event) {
              return _vm.edit(record);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("socialLogin.edit")) + " ")]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: record.loginSwitch == 0 ? _vm.$t("EnableMessage") : _vm.$t("disabledMessage"),
            "ok-text": _vm.$t("yes"),
            "cancel-text": _vm.$t("no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirm(record);
            },
            cancel: _vm.cancel
          }
        }, [_c("a", [_vm._v(_vm._s(record.loginSwitch == 0 ? _vm.$t("Enable") : _vm.$t("disabled")))])]), record.platformType == 0 || record.platformType == 4 ? [_c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a", {
          staticClass: "ant-dropdown-link",
          on: {
            click: function click($event) {
              return _vm.clickNotice(record);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("socialLogin.notify")) + " ")])] : _vm._e()], 2);
      }
    }])
  })], 1), _c("fromModel", {
    attrs: {
      title: _vm.title,
      modalVisible: _vm.visible,
      form: _vm.form,
      formList: _vm.formList,
      rules: _vm.rules,
      FormWidth: _vm.formWidth,
      dialogStyle: _vm.dialogStyle,
      errorTip: _vm.errorTip
    },
    on: {
      ok: _vm.ok,
      cancel: _vm.cancel2
    }
  }), _c("notifySetting", {
    attrs: {
      data: _vm.notifyData,
      title: _vm.settingTitle,
      settingVisible: _vm.settingVisible,
      width: _vm.width,
      showHtml: _vm.showHtml,
      html: _vm.html,
      columnsNotify: _vm.columnsNotify,
      notiType: _vm.notiType
    },
    on: {
      SettingCancel: _vm.settingCancel,
      SettingOk: _vm.SettingOk,
      notifyPreview: _vm.notifyPreview,
      "update:showHtml": function updateShowHtml($event) {
        _vm.showHtml = $event;
      },
      "update:show-html": function updateShowHtml($event) {
        _vm.showHtml = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };